import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "about__info__value d-flex align-items-center"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = { class: "ml-1 text-white bg-danger p-1 border-radius" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "ml-1 text-white bg-danger p-1 border-radius" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServiceRow',
    props: {
        service: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_ctx.service)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.service.custServiceName) + " ", 1),
                        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", null, _toDisplayString(_ctx.service.custServiceId), 1)
                    ]),
                    (_ctx.service.suspended)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 0,
                            title: _ctx.$t('SERVICE_SUSPENDED'),
                            class: "ml-4 d-flex align-items-center"
                        }, [
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "atom-circle atom-circle--danger" }, "!", -1)),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("SUSPENDED")), 1)
                        ], 8, _hoisted_2)), [
                            [_directive_tooltip]
                        ])
                        : _createCommentVNode("", true),
                    (_ctx.service.discontinued)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 1,
                            title: _ctx.$t('SERVICE_DISCONTINUED'),
                            class: "ml-4 d-flex align-items-center"
                        }, [
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "atom-circle atom-circle--danger" }, "!", -1)),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("DISCONTINUED")), 1)
                        ], 8, _hoisted_4)), [
                            [_directive_tooltip]
                        ])
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
